import { styled } from "@mui/material";

export const StyledHeader = styled('h3')({
    color: "rgba(33,77,77,1)",
    padding: "0",
    margin: "6px 0 2px",
    fontFamily: "Montserrat, Arial",
    fontSize: "24px",
    fontWeight: "700",
  });